'use strict';

var User_v1alpha1_schema = require('../schema/kinds/User.v1alpha1.schema.json.cjs.js');
var util = require('./util.cjs.js');

const userEntityV1alpha1Validator = util.ajvCompiledJsonSchemaValidator(User_v1alpha1_schema.default);

exports.userEntityV1alpha1Validator = userEntityV1alpha1Validator;
//# sourceMappingURL=UserEntityV1alpha1.cjs.js.map
